import React from 'react'
import { hooks } from '@front/volcanion'

import EventRow from './Event'
import ActionRow from './Action'

const withContainer = props => {
  const [model_name] = hooks.useFormState('model_name')

  return model_name === 'event'
    ? <EventRow {...props} />
    : <ActionRow {...props} />
}

export default withContainer
